var _path, _path2, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.8c2.67 0 3 0 4 .06a5.61 5.61 0 011.86.34 3.33 3.33 0 011.9 1.9 5.61 5.61 0 01.38 1.9c.05 1 .06 1.37.06 4s0 3-.06 4a5.61 5.61 0 01-.34 1.86 3.33 3.33 0 01-1.9 1.9 5.61 5.61 0 01-1.86.34c-1 .05-1.37.06-4 .06s-3 0-4-.06a5.61 5.61 0 01-1.94-.3 3.33 3.33 0 01-1.9-1.9 5.61 5.61 0 01-.34-1.9c0-1-.06-1.37-.06-4s0-3 .06-4a5.61 5.61 0 01.34-1.9 3.33 3.33 0 011.9-1.9A5.61 5.61 0 018 3.86c1 0 1.37-.06 4-.06M12 2c-2.72 0-3.06 0-4.12.06a7.59 7.59 0 00-2.43.46 4.85 4.85 0 00-1.77 1.16 4.85 4.85 0 00-1.16 1.77 7.59 7.59 0 00-.46 2.43C2 8.94 2 9.28 2 12s0 3.06.06 4.12a7.59 7.59 0 00.46 2.43 4.85 4.85 0 001.16 1.77 4.85 4.85 0 001.77 1.16 7.59 7.59 0 002.43.46C8.94 22 9.28 22 12 22s3.06 0 4.12-.06a7.59 7.59 0 002.43-.46 5.19 5.19 0 002.93-2.93 7.59 7.59 0 00.46-2.43c0-1.06.06-1.4.06-4.12s0-3.06-.06-4.12a7.59 7.59 0 00-.46-2.43 4.85 4.85 0 00-1.16-1.77 4.85 4.85 0 00-1.77-1.16 7.59 7.59 0 00-2.43-.46C15.06 2 14.72 2 12 2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6.86A5.14 5.14 0 1017.14 12 5.14 5.14 0 0012 6.86zm0 8.47A3.33 3.33 0 1115.33 12 3.33 3.33 0 0112 15.33z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.34,
    cy: 6.66,
    r: 1.2
  })));
}

export default SvgInstagram;